const internationalDate = (value) => {
  if (!value) {
    return false;
  }
  const dateArray = value.split('/');

  const day = parseInt(dateArray[0], 10);
  const month = parseInt(dateArray[1], 10);
  const year = parseInt(dateArray[2], 10);

  const dayOk = day > 0 && day < 32;
  const monthOk = month > 0 && month < 13;
  const yearOk = year > 1900 && year <= new Date().getFullYear();

  return dayOk && monthOk && yearOk;
};

export default internationalDate;
